<template>
<div class="home">
  <div class="content">
    <img :src="require('@/assets/img/linli110/title.png')" alt="" class="title">
    <img :src="require('@/assets/img/linli110/banner.png')" alt="" class="banner">
    <div class="btn" @click="toProblemAdd">
      <div class="btn-content">
        <div class="top">
          <img :src="require('@/assets/img/linli110/report.png')" alt="">
          <span class="top-title">问题建议</span>
        </div>
        <div class="divider"></div>
        <div class="bottom">
          <span>诉求表达、事件上报</span>
        </div>
      </div>
    </div>
    <div class="btn" @click="toInformAdd">
      <div class="btn-content">
        <div class="top">
          <img :src="require('@/assets/img/linli110/inform.png')" alt="">
          <span class="top-title">消防举报</span>
        </div>
        <div class="divider"></div>
        <div class="bottom">
          <span>消防安全，有奖举报</span>
        </div>
      </div>
    </div>
    <div class="btn" @click="toConsult">
      <div class="btn-content">
        <div class="top">
          <img :src="require('@/assets/img/linli110/consult.png')" alt="">
          <span class="top-title">政策咨询</span>
        </div>
        <div class="divider"></div>
        <div class="bottom">
          <span>民生服务、政策咨询</span>
        </div>
      </div>
    </div>
  </div>
  <div class="footer">
    <div>本服务由杭州市上城区紫阳街道提供</div>
    <div>服务咨询热线：<span style="color: #3791D3">0571-86071799</span></div>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      query: null
    }
  },
  created () {
    this.query = this.$route.query
  },
  methods: {
    toConsult () {
      this.$router.push({path: '/ai-chat', query: this.query})
    },
    toProblemAdd () {
      this.$router.push({path: '/problemAdd?isGroup=True&groupName=网页&isQyWx=0&fromHome=1', query: {orgId: this.query.street, community: this.query.community}})
    },
    toInformAdd () {
      this.$router.push({path: '/informAdd?isGroup=True&groupName=网页&isQyWx=0&fromHome=1', query: {orgId: this.query.street, community: this.query.community}})
    },
  }
}
</script>
<style scoped lang="scss">
.home {
  min-height: 100vh;
  background-color: #fff;
  .content {
    padding: 50px 32px;
    width: 750px;
    height: 1330px;
    text-align: center;
    background-image: url("~@/assets/img/linli110/bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .title {
      width: 352px;
      height: 68px;
    }
    .banner {
      margin: 56px 0 14px;
      width: 688px;
      height: 306px;
    }
    .btn {
      margin-top: 24px;
      width: 688px;
      height: 218px;
      background-color: #fff;
      border-radius: 14px;
      padding: 14px 8px;
      .btn-content {
        width: 672px;
        height: 190px;
        background: linear-gradient( 180deg, #50ABE4 0%, #E5BBBC 100%);
        border-radius: 14px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .top {
          margin-top: 26px;
          display: flex;
          align-items: center;
          img {
            width: 70px;
            height: 70px;
          }
          .top-title {
            margin-left: 26px;
            font-size: 30px;
            color: #FEFDFE;
          }
        }
        .divider {
          margin: 12px 0 20px 0;
          width: 234px;
          height: 1px;
          background-color: #FEFDFE;
        }
        .bottom {
          font-size: 26px;
          color: #FEFDFE;
          opacity: .8;
        }
      }
    }
  }
  .footer {
    text-align: center;
    margin-top: 28px;
    padding-bottom: 12px;
    color: #000000;
    font-size: 24px;
    line-height: 34px;
    font-weight: 500;
  }
}
</style>
